import React, { useEffect } from 'react';
import gtmService from '../../../../../utils/gtm';
import { useRootSelector } from '../../../../../store/hooks';
import {
  selectArticleHome,
  selectArticleHomeGated,
} from '../../../../../store/features/articles/home';
import {
  selectLeadGenForm,
  selectLeadGenFormLoaded,
} from '../../../../../store/features/leadGen';
import { MetaTags } from '../../../shared/MetaTags';
import { ArticleHome } from './ArticleHome';
import { LeadGenForm } from './LeadGenForm';
import { useCreateArticleCanonicalUrl } from '../../../../../hooks/useCreateArticleCanonicalUrl';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import { siteTypesEnum } from '../../../../../helpers';

export function Article() {
  const {
    articleHome: {
      data: {
        title: articleTitle,
        summary,
        imageUrl,
        contentType,
        pathOfPrimarySite,
        tenantOfPrimarySite,
        typeOfPrimarySite,
        articlePath,
      },
    },
    articleGated,
    leadGen: { teaser },
    leadGenLoaded,
    pageConfig: { tenantId },
  } = useRootSelector((state) => ({
    articleHome: selectArticleHome(state),
    articleGated: selectArticleHomeGated(state),
    leadGen: selectLeadGenForm(state),
    leadGenLoaded: selectLeadGenFormLoaded(state),
    pageConfig: selectPageConfig(state),
  }));
  const { BRAND_HUB } = siteTypesEnum();
  const canonicalUrl = useCreateArticleCanonicalUrl(
    pathOfPrimarySite,
    typeOfPrimarySite,
    tenantOfPrimarySite,
    articlePath,
  );
  const title = articleTitle || teaser?.articleTitle;
  const description = summary || teaser?.teaserHeading;
  const thumbnail = imageUrl || teaser?.thumbnail?.path;

  useEffect(() => {
    gtmService.pushContentType(contentType, 'Set article home content type');
    gtmService.isContentGated(articleGated);
  }, [articleGated, contentType]);

  const noindex =
    typeOfPrimarySite !== BRAND_HUB || tenantId !== tenantOfPrimarySite;
  const robots = noindex ? 'noindex, nofollow' : 'index, follow';

  return (
    <>
      <MetaTags
        title={title}
        description={description}
        thumbnail={thumbnail}
        canonicalUrl={canonicalUrl}
        robots={robots}
      />
      {leadGenLoaded ? <LeadGenForm /> : <ArticleHome />}
    </>
  );
}
